export default __webpack_public_path__ + "media/zurb/img/playground/financial-concept-hero-e14dc636fa91848d8db052f301f5476d.png";